import React from 'react';
import { Target, Lightbulb } from 'lucide-react';
interface InsightCardProps {
  payload: any;
}
export function InsightCard({
  payload
}: InsightCardProps) {
  if (payload.score) {
    return <div className="mt-3 bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl p-4 text-white" data-id="element-111">
        <div className="flex items-center gap-2 mb-2" data-id="element-112">
          <Target size={16} data-id="element-113" />
          <p className="text-xs font-semibold uppercase tracking-wide" data-id="element-114">
            Credit Score
          </p>
        </div>
        <p className="text-3xl font-black" data-id="element-115">{payload.score}</p>
        <p className="text-xs text-primary-200 mt-1" data-id="element-116">
          ↑ +{payload.change} points this year
        </p>
        {payload.tip && <div className="mt-3 bg-white/10 rounded-lg p-2" data-id="element-117">
            <p className="text-xs flex items-start gap-1" data-id="element-118">
              <Lightbulb size={12} className="mt-0.5 shrink-0" data-id="element-119" /> {payload.tip}
            </p>
          </div>}
      </div>;
  }
  if (payload.netWorth) {
    return <div className="mt-3 bg-gradient-to-br from-accent-500 to-accent-700 rounded-xl p-4 text-white" data-id="element-120">
        <p className="text-xs font-semibold uppercase tracking-wide mb-1" data-id="element-121">
          Net Worth
        </p>
        <p className="text-3xl font-black" data-id="element-122">
          ${payload.netWorth.toLocaleString()}
        </p>
        <p className="text-xs text-white/80 mt-1" data-id="element-123">
          ↑ +${payload.change.toLocaleString()} (+{payload.changePercent}%) this
          year
        </p>
      </div>;
  }
  return <div className="mt-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl p-3" data-id="element-124">
      <div className="flex items-center gap-2 mb-2" data-id="element-125">
        <Lightbulb size={14} className="text-amber-500" data-id="element-126" />
        <p className="text-xs font-semibold text-amber-700 dark:text-amber-400" data-id="element-127">
          AI Insights
        </p>
      </div>
      <p className="text-xs text-amber-800 dark:text-amber-300" data-id="element-128">
        Personalized recommendations generated based on your spending patterns.
      </p>
    </div>;
}